import { getEstadisticasAbonadas, getEstadisticasGeneral, getEstadisticasInfraccionesSemaforos, getEstadisticasTipo } from "../services/estadisticas.service";
import { useEstadisticasStore } from "../store/estadisticasStore";

export const getEstadisticasGeneralHandler = async (setActasCsv, payload) => {
  const result = await getEstadisticasGeneral(payload);
  if (result) {
    useEstadisticasStore.setState({ general: result });
    // console.log(result);
    // setPaginateCfg({ ...paginado });
  }
};

export const getEstadisticasInfraccionesSemaforosHandler = async (setActasCsv, payload) => {
  const result = await getEstadisticasInfraccionesSemaforos(payload);
  if (result) {
    useEstadisticasStore.setState({ infracciones: result });
    // console.log(result);
    // setPaginateCfg({ ...paginado });
  }
};
export const getEstadisticasTipoHandler = async (setActasCsv, payload) => {
  const result = await getEstadisticasTipo(payload);
  if (result) {
    useEstadisticasStore.setState({ vehiculos: result });
    // console.log(result);
    // setPaginateCfg({ ...paginado });
  }
};
export const getEstadisticasAbonadasHandler = async (setActasCsv, payload) => {
  const result = await getEstadisticasAbonadas(payload);
  if (result) {
    useEstadisticasStore.setState({ abonadas: result });
    // console.log(result);
    // setPaginateCfg({ ...paginado });
  }
};
